import React from "react";
import { Box } from "@chakra-ui/react";
import { ContentHero } from "../styles";
import useFismaAttrQuery from "../hooks/useFismaAttrQuery";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";

const Content = () => {
  const { data: result } = useFismaAttrQuery();
  const attributes = result!.data?.attributes;
  const { heading } = attributes ?? {};

  return (
    <Box my={10}>
      <ResponsiveContainer>
        <ContentHero dangerouslySetInnerHTML={{ __html: heading! }} />
      </ResponsiveContainer>
    </Box>
  );
};

export default Content;
